import Link from "next/link"
import Button from "../General/Button"
import helpers from "../../utils/helpers"

function BulkDeals() {
    return (
        <div id="bulk-deals" className='--align py-10 lg:py-[60px]'>
            <div className="md:flex md:flex-row-reverse md:justify-between md:items-center">
                <div className='md:w-[50%] lg:w-[52%]'>
                    <img className='w-full md:w-full' src="/Home/BulkDeals.svg" alt="BulkDeals" loading='lazy'/>
                </div>

                <div className='mt-[20px] md:w-[40%] lg:w-[40%]'>
                    <h5 className='text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]'>Bulk Deals</h5>

                    <p className='text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]'>
                        With APIdrug, you have the power to access large group buying deals by joining other buyers who share 
                        your needs. This helps you save money by securing lower-than-market prices and hedging against future
                        price changes. This service is especially helpful for proactive companies that plan their procurement 
                        ahead of time.
                    </p>
                    
                    <p onClick={() => helpers.scrollTo('enquiry-section', 140)} className='w-[48%] lg:w-[193px] block mt-[32px]'>
                        <Button styles = "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]">
                            Open Bulk Deals
                        </Button>
                    </p>
                    {/* <Link href={'/spot-buying'} className='w-[48%] lg:w-[193px] block mt-[32px]'>
                        <Button styles = "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]">
                            Open Bulk Deals
                        </Button>
                    </Link> */}
                </div>
            </div>

        </div>
    )
}

export default BulkDeals